<ng-container *ngIf="store$ | async as store; else createStoreForm">
  <div class="container">
    <div
      gdAreas="photo info | details details"
      gdAreas.lt-md="photo | info | details"
      gdColumns="1fr 3fr"
      gdColumns.sm="repeat(auto-fill, minmax(400px, 2fr))"
      gdColumns.xs="repeat(auto-fill, minmax(300px, 1fr))"
      gdGap="16px"
      gdRows="auto auto"
      gdRows.lt-md="auto auto auto"
    >
      <div gdArea="photo">
        <app-store-image [store]="store" [maxWidth]="'200px'"></app-store-image>
      </div>
      <div gdArea="info">
        <div fxLayout="row">
          <h1>
            <b>
              {{ store.name }}
            </b>
          </h1>
          <button
            gaEvent="open_edit_store"
            (click)="openEditDialogue(store)"
            color="primary"
            mat-icon-button
          >
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <p>
          {{ store.description }}
        </p>
        <br />
        <div fxLayout="row">
          <app-onboarding [store]="store"></app-onboarding>
        </div>
        <br />
        <div fxLayout="row">
          <app-subscriptions></app-subscriptions>
        </div>
      </div>
      <div gdArea="details">
        <div class="container">
          <h1 id="productList"><b>Tous les produits</b></h1>
          <div
            fxLayout="row wrap"
            fxLayoutAlign="start center"
            fxLayoutGap="16px grid"
          >
            <ng-container
              *ngIf="storeProducts$ | async as storeProducts; else noProducts"
            >
              <div
                *ngFor="let product of storeProducts"
                fxFlex="25"
                fxFlex.lt-md="50"
              >
                <app-product-management-card
                  (productDeleted)="productDeleted()"
                  [product]="product"
                ></app-product-management-card>
              </div>
              <app-add-product
                (addedProduct)="addProduct()"
                [store]="store"
              ></app-add-product>
            </ng-container>
            <ng-template #noProducts>
              <app-add-product
                (addedProduct)="addProduct()"
                [store]="store"
              ></app-add-product>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <br />
  </div>
  <mat-card fxLayout="row" fxLayoutAlign="center center" id="lowbanner">
    <div
      class="container"
      fxFlex
      fxLayout="row"
      fxLayout.xs="column"
      fxLayoutAlign="start center"
      fxLayoutGap="2rem"
    >
      <!--main image-->
      <!--content-->
      <div>
        <br /><br /><br />
        <br /><br /><br />
        <h1 class="bannerText">Bienvenue dans votre espace boutique !</h1>
        <p class="bannerText">
          Des questions ? Consultez notre FAQ vendeurs ou écrivez-nous à
          <a class="bannerText" href="mailto:info@creasources.ca"
            >info@creasources.ca</a
          >
        </p>
        <p class="bannerText">
          Des commentaires ? Nous améliorons continuellement la plateforme en
          fonction de vos rétroactions. Écrivez-nous
        </p>
        <p class="bannerText">
          Un problème technique ? Signalez-le à
          <a class="bannerText" href="mailto:support@creasources.ca"
            >support@creasources.ca</a
          >
        </p>
        <br /><br /><br />
      </div>
    </div>
  </mat-card>
</ng-container>

<ng-template #createStoreForm>
  <div class="container">
    <h2>Créez votre boutique</h2>
    <div fxLayout="column">
      <form (ngSubmit)="submitNewStore()" [formGroup]="addStoreForm">
        <app-store-form formControlName="store"></app-store-form>
        <div>
          <button
            [disabled]="addStoreForm.invalid || submitted"
            [class.spinner]="submitted"
            gaEvent="create_store"
            color="primary"
            data-test="submitNewStore"
            mat-raised-button
          >
            Créer ma boutique
          </button>
        </div>
      </form>
    </div>
    <br />
    <h2>Formules d'adhésion</h2>
    <h4>
      Crésources offre deux formules d'adhésion pour les vendeurs. Vous êtes
      automatiquement inscrit à la formule standard lorsque vous créez votre
      boutique. Vous pouvez adhérer à la formule premium une fois la boutique
      ouverte.
    </h4>
    <br />
    <mat-table [dataSource]="dataSource" class="mat-elevation-z0">
      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <ng-container matColumnDef="raison">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.raison }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="standard">
        <mat-header-cell *matHeaderCellDef>Standard</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.standard }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="premium">
        <mat-header-cell *matHeaderCellDef>Premium</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.premium }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <br />
    <p>
      *La commission sert au développement et au maintien de la plateforme. La
      commission inclut, entre autres, les frais d’hébergement des ressources,
      les frais d’ouverture des boutiques, les frais sur chaque vente, certains
      frais de transaction, la gestion des taxes et les frais de publicité.
    </p>
    <p>
      **Nous transférons le total de vos ventes directement dans votre compte
      bancaire à tous les mois, sans frais et sans solde minimal requis. Peu
      importe le montant de vos ventes, vous recevrez toujours votre argent.
    </p>
  </div>
</ng-template>
